import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const Dialogs: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Dialogs" */ '../src/Dialogs.tsx')).Dialogs,
});
